export function Problem() {
  const problems = [
    {
      icon: '🤯',
      title: 'Complex SQL Required',
      description:
        'Business teams need technical expertise to extract insights from their data.',
    },
    {
      icon: '⏱️',
      title: 'Slow Query Development',
      description:
        'Writing and debugging SQL queries takes hours or days for complex analysis.',
    },
    {
      icon: '🔒',
      title: 'Security Concerns',
      description:
        'Giving direct database access to business users poses security risks.',
    },
    {
      icon: '📊',
      title: 'Manual Chart Creation',
      description:
        'Results need to be manually formatted into charts and presentations.',
    },
  ];

  return (
    <section id="problem" className="section-padding bg-white">
      <div className="container-wrapper">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Data Analysis Shouldn&apos;t Be This Hard
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Most teams struggle to get insights from their data because
            traditional tools require technical expertise and create unnecessary
            bottlenecks.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {problems.map((problem, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl mb-4">{problem.icon}</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {problem.title}
              </h3>
              <p className="text-gray-600">{problem.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-red-50 border border-red-200 rounded-lg p-8 max-w-2xl mx-auto">
            <h3 className="text-xl font-semibold text-red-800 mb-2">
              The Result?
            </h3>
            <p className="text-red-700">
              Business decisions are delayed, opportunities are missed, and
              teams become dependent on overworked technical resources for basic
              data questions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
